import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pessoa' };
/////////////////////////////////////////////////////////////////////////////////

export function listPessoaCadastro(param) {
  return httpService.get({...args, args: param});
}
